import React from 'react'
import './Words.css'
import axios from 'axios'
import text from './languages'

class Words extends React.Component {
  state = {
    definitions: {}
  }
  getWordsForLetter = (letter) => {
    return this.props.wordsList.filter(
      (word) => {
        return word[0] === letter
      }
    )
  }
  
renderWordsList = () => {
  const { wordsList, uniqueLetters } = this.props
  if (!this.props.isGamePaused) {
    return uniqueLetters.map((letter, index) => {
      return (
        <React.Fragment key={index}>
          {this.renderLetter({ wordsList, letter })}
          {this.renderWordsForLetter({ wordsList, letter })}
        </React.Fragment>
      )
    })
  }
}

renderLetter = ({ wordsList, letter }) => {
  if (this.hasWords({ wordsList, letter })) {
    return (
      <div className="letter" key={letter}>
        {letter}
      </div>
    )
  }
}

renderWordsForLetter = ({ wordsList, letter }) => {
  return wordsList.map((word) => {
    if (word[0].toUpperCase() === letter.toUpperCase()) {
      return (
        <div 
          className={`word ${this.isLastWord({wordsList, word})}`} 
          key={word}
          onMouseOver={(e) => this.onWordMouseOver({ e, word })}
        >
          {word}
          <span className="tooltip-text">{this.renderDefinitions(word)}</span>
        </div>
      )
    }
    else {
      return null
    }
  })
}

renderDefinitions = (word) => {
  const definitions = this.state.definitions[word]
  if (!definitions) {
    return <span>{text.WORDS_LOADING_DEF[this.props.langUI]}</span>
  } else {
    return definitions.map((el, index) => {
      return (
        <React.Fragment key={`${word}-${index}-definition`}>
          <span>{`${index + 1}. ${el.definition} `}</span>
        </React.Fragment>
      )
    })
  }
}

fetchWordDefinition = async (word) => { 
  let response
  const { wordsLang } = this.props
  try {
    response = await axios.get(`https://api.dictionaryapi.dev/api/v2/entries/${wordsLang}/${word}`)
  } catch (error) {
    if (error) {
      response = "error"
    }
  } 
  let fetchedDefinitions
  if (response !== "error") {
    fetchedDefinitions = response.data[0].meanings[0].definitions
  } else {
    fetchedDefinitions = [{definition: text.WORDS_DEF_NOT_FOUND[this.props.langUI]}]
  }
  const newDefinitions = {...this.state.definitions}
  newDefinitions[word] = fetchedDefinitions
  this.setState({definitions: {...newDefinitions}})
}

onWordMouseOver = ({ e, word }) => {
  let definition = this.state.definitions[word]
  if (!definition) {
    this.fetchWordDefinition(word)
  } 
}

hasWords = ({ wordsList, letter }) => {
  let hasWords = false
  for (let i = 0; i < wordsList.length; i++) {
    if (wordsList[i][0].toUpperCase() === letter.toUpperCase()) {
      hasWords = true
      break 
    }
  }
  return hasWords
}

isLastWord = ({ wordsList, word }) => {
  let isLast = ''
  const lastWord = wordsList[wordsList.length - 1]
  if (lastWord.toUpperCase() === word.toUpperCase()) {
    isLast = 'last'
  }
  return isLast
}

  render() {
    return (
      <div className="words">
        {this.props.children}
        {this.renderWordsList()}
      </div>
    )
  }
}

export default Words